import {Dispatch, useState} from 'react';
import {StatusCallAccountController} from '../../../api/status-calls/status-call-account.controller';
import {StatusCallController} from '../../../api/status-calls/status-call.controller';
import {useAsyncEffect} from '../../../hook/use-initial-load';
import {StatusCallAccountSummaryModel} from '../../../model/status-calls/status-call-account-summary.model';
import {StatusCallModel} from '../../../model/status-calls/status-call.model';

export namespace StatusCallsPageHooks {
  export const useCalendarCalls = (from: string, to: string): [StatusCallModel[], Dispatch<StatusCallModel[]>, () => Promise<void>] => {
    const [calls, setCalls] = useState<StatusCallModel[]>([]);
    const refresh = async () => {
      setCalls(await StatusCallController.getStatusCallsCalendar(from, to));
    };
    useAsyncEffect(async () => {
      await refresh();
    }, [from, to]);
    return [calls, setCalls, refresh];
  };

  export const useStatusCallAccount = (organizationId: string | null): [StatusCallAccountSummaryModel | null, Dispatch<StatusCallAccountSummaryModel | null>, () => Promise<void>] => {
    const [account, setAccount] = useState<StatusCallAccountSummaryModel | null>(null);
    const refresh = async () => {
      if (organizationId) {
        setAccount(await StatusCallAccountController.getStatusCallAccount(organizationId));
      } else {
        setAccount(null);
      }
    };
    useAsyncEffect(async () => {
      await refresh();
    }, [organizationId]);
    return [account, setAccount, refresh];
  };
}
